// extracted by mini-css-extract-plugin
module.exports = {"videoPlayer":"VideoApp_videoPlayer__3tWzw"};